export default [
    {
        header: 'Gestión',
    },
    {
        title: 'Portal',
        route: 'home',
        icon: 'HomeIcon',
        resource: 'PortalClient',
        action: 'read',
    },
    {
        title: 'Suscripción',
        route: 'suscripcion',
        icon: 'FileIcon',
        resource: 'PortalClient',
        action: 'read',
    },
    {
        title: 'Pagos',
        route: 'pagos',
        icon: 'DollarSignIcon',
        resource: 'PortalClient',
        action: 'read',
    },
    {
        title: 'Mensualidades con Adjunto',
        route: 'monthly-attachments',
        icon: 'PaperclipIcon',
        resource: 'PortalClient',
        action: 'read',
    },
]
